module.exports = __webpack_public_path__ + "img/nocciole_pack.7cba9ff7.png";